module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/todo_en-05d8b701836e3e93e341313b8a1a7082.webp";